import React                              from 'react';
import { HashRouter as Router, Route }    from 'react-router-dom';
import Projects                           from './ProjectsList'
import Folder                             from './Folder';
import User                               from './User';
import NewProject                         from './NewProject';
import Project                            from './Project';
import { Login, Logout }                  from './Login'
import Alert                              from './Alert';

export default function App(props){
    // ну а пока суть да дело - рисуем что можем
    return (
        <Router>
            <div className="App">
                <Route exact path="/" component={Projects} />
                <Route path="/login" component={Login} />
                <Route path="/access_token=:hash" component={Login} />
                <Route path="/logout" component={Logout} />
                <Route path="/new_project" component={NewProject} />
                <Route path="/folder/:id" render={ (props) => <Folder {...props}/> } />
                <Route path="/project/:id" render={ (props) => <Project {...props}/> } />
                <Route path="/user/:id" render={ (props) => <User {...props}/> } />
                <Alert />
            </div>
        </Router>
    );
}